import { Injectable } from '@angular/core';
import { ShipmentService } from './shipment-service';
import { DbService } from './db.service';
import { ToastService } from './toast.service';
import { firstValueFrom } from 'rxjs';
import { DeliveryStatusService } from './delivery-status-service';
import { JustificationService } from './justification-service';

@Injectable({
  providedIn: 'root'
})
export class QrReaderService {

  constructor(private shipmentService:ShipmentService, private dbService:DbService,
              private toast:ToastService, private deliveryStatusService:DeliveryStatusService,
              private justificationService:JustificationService
  ) { }
  
  async qrCodeCaptured(qrValue: string): Promise<boolean> {
    const shipmentId = this.getShipmentIdFromQr(qrValue);

    if (!shipmentId) {
      this.toast.warn('Invalid QR code', 'The QR does not contain a valid shipment id.', 5000);
      return false;
    }

    try {
      if (await this.dbService.getShipmentById(shipmentId)) {
        this.toast.warn('Shipment already exists', 'This shipment has already been scanned and stored.', 5000);
        return false;
      }
      if(!navigator.onLine){
        this.toast.warn('Device is offline', 'You need access to internet to add a new shipment', 5000);
        return false;
      }

      const result = await firstValueFrom(this.shipmentService.getShipment(shipmentId));
      if (result.success && result.data) {
        const shipment = result.data;        
        await this.dbService.saveShipments(shipment);
        this.deliveryStatusService.getActive().subscribe(result =>{
          if(result.data){
            this.dbService.saveDeliveryStatusList(result.data);
          }
        });

        this.justificationService.getActive().subscribe(result =>{
          if(result.data){
            this.dbService.saveJustificationList(result.data);
          }
        });

        return true;
      }else{
        return false;
      }
    } catch (error) {
      return false;
    }
  }

  private getShipmentIdFromQr(qrValue: string): number | null {
    const value = qrValue?.trim();
    if (!value) {
      return null;
    }

    if (/^\d+$/.test(value)) {
      return Number(value);
    }

    try {
      const url = new URL(value);
      const shipmentIdParam = url.searchParams.get('shipmentId');
      if (!shipmentIdParam || !/^\d+$/.test(shipmentIdParam)) {
        return null;
      }
      return Number(shipmentIdParam);
    } catch {
      return null;
    }
  }



}
